import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: '/jfb2b-www/dist',
    routes: [{
            path: '/',
            name: 'root',
            redirect: {
                name: 'IndexPc',
            },
        },

        {
            path: '/index',
            name: 'Index',
            component: require('@/page/index/Index'),
        },
        {
            path: '/qcxj-index',
            name: 'QcxjIndex',
            component: require('@/page/apps/qcxj/QcxjIndex'),
        },
        {
            path: '/qcxj-station-apply',
            name: 'QcxjStationApply',
            component: require('@/page/apps/qcxj/StationApply'),
        },
        {
            path: '/qcxj-station-bind',
            name: 'QcxjStationBind',
            component: require('@/page/apps/qcxj/StationBind'),
        },
        {
            path: '/qcxj-station-list',
            name: 'QcxjStationList',
            component: require('@/page/apps/qcxj/StationList'),
        },
        {
            path: '/qcxj-station-result',
            name: 'QcxjStationResult',
            component: require('@/page/apps/qcxj/StationResult'),
        },
        {
            path: '/qcxj-station-cert',
            name: 'QcxjStationCert',
            component: require('@/page/apps/qcxj/StationCert'),
        },
        {
            path: '/qcxj-exame-apply-list',
            name: 'ExameApplyList',
            component: require('@/page/apps/qcxj/ExameApplyList'),
        },
        {
            path: '/qcxj-exame-apply-slist',
            name: 'ExameApplySList',
            component: require('@/page/apps/qcxj/ExameApplySList'),
        },
        {
            path: '/qcxj-exame-apply-form-basic',
            name: 'ExameApplyFormBasic',
            component: require('@/page/apps/qcxj/ExameApplyFormBasic'),
        },
        {
            path: '/qcxj-exame-apply-share-list',
            name: 'ExameApplyShareList',
            component: require('@/page/apps/qcxj/ExameApplyShareList'),
        },
        {
            path: '/qcxj-exame-score-detail',
            name: 'ExameScoreDetail',
            component: require('@/page/apps/qcxj/ExameScoreDetail'),
        },
        {
            path: '/qcxj-exame-apply-join',
            name: 'ExameApplyJoin',
            component: require('@/page/apps/qcxj/ExameApplyJoin'),
        },
        {
            path: '/qcxj-exame-apply-join-detail',
            name: 'ExameApplyJoinDetail',
            component: require('@/page/apps/qcxj/ExameApplyJoinDetail'),
        },
        {
            path: '/qcxj-exame-apply-join-member-list',
            name: 'ExameApplyJoinMemberList',
            component: require('@/page/apps/qcxj/ExameApplyJoinMemberList'),
        },
        {
            path: '/qcxj-exame-apply-member-list',
            name: 'ExameApplyMemberList',
            component: require('@/page/apps/qcxj/ExameApplyMemberList'),
        },
        {
            path: '/qcxj-exame-apply-member-detail',
            name: 'ExameApplyMemberDetail',
            component: require('@/page/apps/qcxj/ExameApplyMemberDetail'),
        },
        {
            path: '/qcxj-exame-apply-order',
            name: 'ExameApplyOrder',
            component: require('@/page/apps/qcxj/ExameApplyOrder'),
        },
        {
            path: '/qcxj-exame-apply-detail',
            name: 'ExameApplyDetail',
            component: require('@/page/apps/qcxj/ExameApplyDetail'),
        },
        {
            path: '/qcxj-exame-apply-member-add-more',
            name: 'ExameApplyMemberAddMore',
            component: require('@/page/apps/qcxj/ExameApplyMemberAddMore'),
        },
        {
            path: '/qcxj-exame-apply-member-add',
            name: 'ExameApplyMemberAdd',
            component: require('@/page/apps/qcxj/ExameApplyMemberAdd'),
        },
        {
            path: '/sai-apply-form-step-1',
            name: 'SaiApplyFormStep1',
            component: require('@/page/apps/sai/SaiApplyFormStep1'),
        },
        {
            path: '/sai-apply-form-step-2',
            name: 'SaiApplyFormStep2',
            component: require('@/page/apps/sai/SaiApplyFormStep2'),
        },
        {
            path: '/sai-apply-form-step-3',
            name: 'SaiApplyFormStep3',
            component: require('@/page/apps/sai/SaiApplyFormStep3'),
        },
        {
            path: '/sai-apply-form-step-4',
            name: 'SaiApplyFormStep4',
            component: require('@/page/apps/sai/SaiApplyFormStep4'),
        },
        {
            path: '/sai-apply-form-step-5',
            name: 'SaiApplyFormStep5',
            component: require('@/page/apps/sai/SaiApplyFormStep5'),
        },
        {
            path: '/sai-apply-form-success',
            name: 'SaiApplyFormSuccess',
            component: require('@/page/apps/sai/SaiApplyFormSuccess'),
        },
        {
            path: '/sai-apply-fapiao',
            name: 'SaiApplyFapiao',
            component: require('@/page/apps/sai/SaiApplyFapiao'),
        },
        {
            path: '/sai-apply-form-success',
            name: 'SaiApplyFormSuccess',
            component: require('@/page/apps/sai/SaiApplyFormSuccess'),
        },
        {
            path: '/sai-data-list',
            name: 'SaiDateList',
            component: require('@/page/apps/sai/SaiDateList'),
        },
        {
            path: '/sai-files-list',
            name: 'SaiFilesList',
            component: require('@/page/apps/sai/SaiFilesList'),
        },
        {
            path: '/sai-result',
            name: 'SaiResult',
            component: require('@/page/apps/sai/SaiResult'),
        },
        {
            path: '/sai-start-list',
            name: 'SaiStartList',
            component: require('@/page/apps/sai/SaiStartList'),
        },
        {
            path: '/isai-apply-form-step-1',
            name: 'ISaiApplyFormStep1',
            component: require('@/page/apps/isai/SaiApplyFormStep1'),
        },
        {
            path: '/isai-apply-form-step-2',
            name: 'ISaiApplyFormStep2',
            component: require('@/page/apps/isai/SaiApplyFormStep2'),
        },
        {
            path: '/isai-apply-form-famliy-step-2',
            name: 'ISaiApplyFormFamliyStep2',
            component: require('@/page/apps/isai/SaiApplyFormFamliyStep2'),
        },
        {
            path: '/isai-apply-form-step-3',
            name: 'ISaiApplyFormStep3',
            component: require('@/page/apps/isai/SaiApplyFormStep3'),
        },
        {
            path: '/isai-apply-form-step-4',
            name: 'ISaiApplyFormStep4',
            component: require('@/page/apps/isai/SaiApplyFormStep4'),
        },
        {
            path: '/isai-apply-form-step-5',
            name: 'ISaiApplyFormStep5',
            component: require('@/page/apps/isai/SaiApplyFormStep5'),
        },
        {
            path: '/isai-apply-form-success',
            name: 'ISaiApplyFormSuccess',
            component: require('@/page/apps/isai/SaiApplyFormSuccess'),
        },
        {
            path: '/isai-apply-form-upload-video',
            name: 'ISaiApplyFormUploadVideo',
            component: require('@/page/apps/isai/SaiApplyFormUploadVideo'),
        },
        {
            path: '/isai-apply-video-list',
            name: 'ISaiApplyVideoList',
            component: require('@/page/apps/isai/SaiApplyVideoList'),
        },
        {
            path: '/isai-cert-list',
            name: 'ISaiCertList',
            component: require('@/page/apps/isai/SaiCertList'),
        },
        {
            path: '/isai-apply-list',
            name: 'ISaiApplyList',
            component: require('@/page/apps/isai/SaiApplyList'),
        },
        {
            path: '/isai-apply-famliy-list',
            name: 'ISaiApplyFamliyList',
            component: require('@/page/apps/isai/SaiApplyFamliyList'),
        },
        {
            path: '/isai-apply-detail',
            name: 'ISaiApplyDetail',
            component: require('@/page/apps/isai/SaiApplyDetail'),
        },
        {
            path: '/isai-apply-famliy-detail',
            name: 'ISaiApplyFamliyDetail',
            component: require('@/page/apps/isai/SaiApplyFamliyDetail'),
        },
        {
            path: '/isai-vote-list',
            name: 'ISaiVoteList',
            component: require('@/page/apps/isai/VoteList'),
        },
        {
            path: '/isai-vote-detail',
            name: 'ISaiVoteDetail',
            component: require('@/page/apps/isai/VoteDetail'),
        },
        {
            path: '/sai-confirm',
            name: 'saiConfirm',
            component: require('@/page/apps/sai/saiConfirm'),
        },
        {
            path: '/sai-confirm-detail1',
            name: 'saiConfirmDetail1',
            component: require('@/page/apps/sai/saiConfirmDetail1'),
        },
        {
            path: '/sai-confirm-detail2',
            name: 'saiConfirmDetail2',
            component: require('@/page/apps/sai/saiConfirmDetail2'),
        },
        {
            path: '/sai-confirm-detail3',
            name: 'saiConfirmDetail3',
            component: require('@/page/apps/sai/saiConfirmDetail3'),
        },
        {
            path: '/sai-confirm-detail4',
            name: 'saiConfirmDetail4',
            component: require('@/page/apps/sai/saiConfirmDetail4'),
        },
        {
            path: '/sai-confirm-detail5',
            name: 'saiConfirmDetail5',
            component: require('@/page/apps/sai/saiConfirmDetail5'),
        },
        {
            path: '/sai-confirm-detail-dinner',
            name: 'saiConfirmDetailDinner',
            component: require('@/page/apps/sai/SaiConfirmDetailDinner'),
        },
        {
            path: '/sai-confirm-manage',
            name: 'saiConfirmManage',
            component: require('@/page/apps/sai/SaiConfirmManage'),
        },
        {
            path: '/sai-confirm-qr1',
            name: 'saiConfirmQr1',
            component: require('@/page/apps/sai/SaiConfirmQr1'),
        },
        {
            path: '/sai-confirm-qr2',
            name: 'saiConfirmQr2',
            component: require('@/page/apps/sai/SaiConfirmQr2'),
        },
        {
            path: '/sai-my-sai',
            name: 'MySai',
            component: require('@/page/apps/sai/MySai'),
        },
        {
            path: '/activity',
            name: 'Activity',
            component: require('@/page/activity/Activity'),
        },
        {
            path: '/activity-my-activity',
            name: 'MyActivity',
            component: require('@/page/apps/activity/MyActivity'),
        },
        {
            path: '/activity-activity',
            name: 'ActivityActivity',
            component: require('@/page/apps/activity/Activity'),
        },
        {
            path: '/activity-activity-detail',
            name: 'ActivityDetail',
            component: require('@/page/apps/activity/ActivityDetail'),
        },
        {
            path: '/activity-activity-content-form',
            name: 'ActivityContentForm',
            component: require('@/page/apps/activity/activityContentForm'),
        },
        {
            path: '/activity-activity-pic-order-form',
            name: 'ActivityPicOrderForm',
            component: require('@/page/apps/activity/ActivityPicOrderForm'),
        },
        {
            path: '/user-member-yundongyuanlist',
            name: 'YundongyuanList',
            component: require('@/page/user/member/YundongyuanList'),
        },
        {
            path: '/user-member-caipanlist',
            name: 'CaipanList',
            component: require('@/page/user/member/CaipanList'),
        },
        {
            path: '/user-member-jiaolianlist',
            name: 'JiaolianList',
            component: require('@/page/user/member/JiaolianList'),
        },
        {
            path: '/user-cert-certindex',
            name: 'CertIndex',
            component: require('@/page/user/cert/CertIndex'),
        },
        {
            path: '/user-cert-certdanwei',
            name: 'CertDanwei',
            component: require('@/page/user/cert/CertDanwei'),
        },
        {
            path: '/user-cert-certdanweibind',
            name: 'CertDanweiBind',
            component: require('@/page/user/cert/CertDanweiBind'),
        },
        {
            path: '/user-cert-certdanweiapply',
            name: 'CertDanweiApply',
            component: require('@/page/user/cert/CertDanweiApply'),
        },
        {
            path: '/user-cert-certdanweiresult',
            name: 'CertDanweiResult',
            component: require('@/page/user/cert/CertDanweiResult'),
        },
        {
            path: '/activityDetail',
            name: 'ActivityDetail',
            component: require('@/page/activity/ActivityDetail'),
        },
        {
            path: '/activityList',
            name: 'ActivityList',
            component: require('@/page/activity/ActivityList'),
        },
        {
            path: '/competitionOrder',
            name: 'CompetitionOrder',
            component: require('@/page/activity/CompetitionOrder'),
        },
        {
            path: '/queryGrade',
            name: 'QueryGrade',
            component: require('@/page/activity/QueryGrade'),
        },
        {
            path: '/indexlayout',
            name: 'indexlayout',
            redirect: '/cmslist',
            components: {
                default: require('@/page/index/IndexLayout'),
            },
            children: [
                // pc端 首页
                {
                    path: '/indexpc',
                    name: 'IndexPc',
                    components: {
                        default: require('@/page/index/IndexPc'),
                    },
                    meta: {
                        title: '首页'
                    }
                },

                {
                    path: '/videoSai',
                    name: 'videoSai',
                    redirect: '/videoSaiList',
                    components: {
                        default: require('@/page/user/mine/MineLayout'),
                    },
                    children: [  
                        {
                            path: '/updateinfo',
                            name: 'UpdataInfo',
                            components: {
                                default: require('@/page/user/mine/UpdataInfo'),
                            },
                            meta: {
                                title: '资料修改',
                                keepAlive: false,
                                tabs: [{
                                    label: '资料修改',
                                    pathName: 'UpdataInfo',
                                }]
                            }
                        },
                        {
                            path: '/accountmanager',
                            name: 'AccountManager',
                            components: {
                                default: require('@/page/user/mine/AccountManager'),
                            },
                            meta: {
                                title: '账户管理',
                                keepAlive: false,
                                tabs: [{
                                    label: '账户管理',
                                    pathName: 'AccountManager',
                                }]
                            }
                        },
                        {
                            path: '/payrecords',
                            name: 'PayRecords',
                            components: {
                                default: require('@/page/user/mine/PayRecords'),
                            },
                            meta: {
                                title: '支付记录',
                                keepAlive: false,
                                tabs: [{
                                    label: '支付记录',
                                    pathName: 'PayRecords',
                                }]
                            }
                        },
                        {
                            path: '/orderList',
                            name: 'orderList',
                            components: {
                                default: require('@/page/index/order/orderList'),
                            },
                            meta: {
                                title: '订单列表',
                                keepAlive: false,
                                tabs: [{
                                    label: '订单列表',
                                    pathName: 'OrderList',
                                }]
                            }
                        },

                    ]
                },

                {
                    path: '/cart',
                    name: 'cart',
                    component: require('@/page/index/Cart'),
                },
                {
                    path: '/businessForm',
                    name: 'BusinessForm',
                    components: {
                        default: require('@/page/index/BusinessForm'),
                    },
                    meta: {
                        title: '供应商入驻'
                    }
                },
                {
                    path: '/aboutus',
                    name: 'aboutUs',
                    components: {
                        default: require('@/page/index/AboutUs'),
                    },
                    meta: {
                        title: '关于我们'
                    }
                },
                // {
                //     path: '/cmsQualificationsSearch',
                //     name: 'CmsQualificationsSearch',
                //     components: {
                //         default: require('@/page/index/cms/CmsQualificationsSearch'),
                //     }
                // },
                {
                    path: '/contentsinglepage',
                    name: 'ContentSinglePage',
                    component: require('@/page/index/cms/ContentSinglePage'),
                    meta: {
                        title: '内容详情'
                    }
                },
                {
                    path: '/login',
                    name: 'login',
                    component: require('@/page/index/login/Login'),
                    meta: {
                        title: '登录'
                    }
                },
                { //萌星闪闪
                    path: '/cutestar',
                    name: 'CuteStar',
                    components: {
                        default: require('@/page/index/CuteStar'),
                    },
                    meta: {
                        title: '少儿经纪'
                    }
                },
                { //国外影城一瞥
                    path: '/foreignfilm',
                    name: 'ForeignFilm',
                    components: {
                        default: require('@/page/index/ForeignFilm'),
                    },
                },
                { //国外影城一瞥
                    path: '/organizationlist',
                    name: 'OrganizationList',
                    components: {
                        default: require('@/page/index/OrganizationList'),
                    }
                },
                {
                    path: '/cmslist',
                    name: 'CmsList',
                    components: {
                        default: require('@/page/index/cms/CmsList'),
                    }
                },
                {
                    path: '/talentlist',
                    name: 'TalentList',
                    components: {
                        default: require('@/page/index/cms/TalentList'),
                    }
                },
                {
                    path: '/cmsdetail',
                    name: 'CmsDetail',
                    components: {
                        default: require('@/page/index/cms/CmsDetail'),
                    },
                },
                {
                    path: '/cate',
                    name: 'Cate',
                    components: {
                        default: require('@/page/index/cms/cate'),
                    }
                },
                {
                    path: '/cmsposition',
                    name: 'CmsPosition',
                    components: {
                        default: require('@/page/index/cms/CmsPosition'),
                    }
                },
                {
                    path: '/goodslist',
                    name: 'goodsList',
                    components: {
                        default: require('@/page/index/goods/GoodsList'),
                    }
                },
                {
                    path: '/goodsdetail',
                    name: 'goodsDetail',
                    components: {
                        default: require('@/page/index/goods/GoodsDetail'),
                    }
                },
                {
                    path: '/orderpay',
                    name: 'OrderPay',
                    components: {
                        default: require('@/page/index/order/OrderPay'),
                    }
                },
                {
                    path: '/weixin_pay',
                    name: 'WeixinPay',
                    components: {
                        default: require('@/page/index/order/WeixinPay'),
                    }
                },
                {
                    path: '/orderdetail',
                    name: 'OrderDetail',
                    components: {
                        default: require('@/page/index/order/OrderDetail'),
                    }
                },
                {
                    path: '/expresstrace',
                    name: 'ExpressTrace',
                    component: require('@/page/index/order/ExpressTrace'),
                  },
                {
                    path: '/cms-single-page',
                    name: 'CmsSinglePage',
                    components: {
                        default: require('@/page/index/cms/CmsSinglePage'),
                    }
                },
                {
                    path: '/cute-single-page',
                    name: 'CuteSinglePage',
                    components: {
                        default: require('@/page/index/cms/CuteSinglePage'),
                    }
                },

                // {
                //     path: '/cmscate',
                //     name: 'CmsCate',
                //     components: {
                //         default: require('@/page/index/cms/CmsCate'),
                //     }
                // },

                // {
                //     path: '/courselist',
                //     name: 'CourseList',
                //     components: {
                //         default: require('@/page/index/course/CourseList'),
                //     }
                // },
                // {
                //     path: '/textlist',
                //     name: 'TextList',
                //     components: {
                //         default: require('@/page/index/cms/TextList'),
                //     }
                // },
                {
                    path: '/coursecontent',
                    name: 'CourseContent',
                    components: {
                        default: require('@/page/index/course/CourseContent'),
                    },

                },
                {
                    path: '/worksdetail',
                    name: 'WorksDetail',
                    components: {
                        default: require('@/page/index/course/WorksDetail'),
                    },

                },
                // {
                //     path: '/videodetail',
                //     name: 'VideoDetail',
                //     components: {
                //         default: require('@/page/index/course/VideoDetail'),
                //     }
                // },
                // {
                //     path: '/textdetail',
                //     name: 'TextDetail',
                //     components: {
                //         default: require('@/page/index/course/TextDetail'),
                //     }
                // },

                {
                    path: '/kaoji-apply-step1',
                    name: 'KaojiApplyStep1',
                    components: {
                        default: require('@/page/apps/kaoji/KaojiApplyStep1'),
                    }
                },
                {
                    path: '/kaoji-apply-step2',
                    name: 'KaojiApplyStep2',
                    components: {
                        default: require('@/page/apps/kaoji/KaojiApplyStep2'),
                    }
                },
                {
                    path: '/kaoji-teacher-apply-step2',
                    name: 'KaojiTeacherApplyStep2',
                    components: {
                        default: require('@/page/apps/kaoji/KaojiTeacherApplyStep2'),
                    }
                },
                {
                    path: '/kaoji-apply-step4',
                    name: 'KaojiApplyStep4',
                    components: {
                        default: require('@/page/apps/kaoji/KaojiApplyStep4'),
                    }
                },
                {
                    path: '/kaoji-apply-step5',
                    name: 'KaojiApplyStep5',
                    components: {
                        default: require('@/page/apps/kaoji/KaojiApplyStep5'),
                    }
                },
                {
                    path: '/kaoji-apply-step6',
                    name: 'KaojiApplyStep6',
                    components: {
                        default: require('@/page/apps/kaoji/KaojiApplyStep6'),
                    }
                },
                {
                    path: '/kaoji-apply-post',
                    name: 'KaojiApplyPost',
                    components: {
                        default: require('@/page/apps/kaoji/KaojiApplyPost'),
                    }
                },
                {
                    path: '/kaoji-exame',
                    name: 'KaojiExame',
                    components: {
                        default: require('@/page/apps/kaoji/Exame'),
                    }
                },
                {
                    path: '/kaoji-exame-test',
                    name: 'KaojiExameTest',
                    components: {
                        default: require('@/page/apps/kaoji/ExameTest'),
                    }
                },
                {
                    path: '/wrong-question-detail',
                    name: 'WrongQuestionDetail',
                    components: {
                        default: require('@/page/user/mine/WrongQuestionDetail'),
                    }
                },
                {
                    path: '/kaoji-exame-result',
                    name: 'KaojiExameResult',
                    components: {
                        default: require('@/page/apps/kaoji/ExameResult'),
                    }
                },
                {
                    path: '/shixun-apply-index',
                    name: 'ShixunApplyIndex',
                    components: {
                        default: require('@/page/apps/shixun/ShixunApplyIndex'),
                    }
                },
                {
                    path: '/shixun-apply-step1',
                    name: 'ShixunApplyStep1',
                    components: {
                        default: require('@/page/apps/shixun/ShixunApplyStep1'),
                    }
                },
                {
                    path: '/yanxue-apply-index',
                    name: 'YanxueApplyIndex',
                    components: {
                        default: require('@/page/apps/yanxue/YanxueApplyIndex'),
                    }
                },
                {
                    path: '/yanxue-apply-step1',
                    name: 'YanxueApplyStep1',
                    components: {
                        default: require('@/page/apps/yanxue/YanxueApplyStep1'),
                    }
                }, {
                    path: '/guoji-apply-index',
                    name: 'GuojiApplyIndex',
                    components: {
                        default: require('@/page/apps/guoji/GuojiApplyIndex'),
                    }
                },
                {
                    path: '/guoji-apply-step1',
                    name: 'GuojiApplyStep1',
                    components: {
                        default: require('@/page/apps/guoji/GuojiApplyStep1'),
                    }
                }, {
                    path: '/saishi-apply-index',
                    name: 'SaishiApplyIndex',
                    components: {
                        default: require('@/page/apps/saishi/SaishiApplyIndex'),
                    }
                },
                {
                    path: '/saishi-apply-step1',
                    name: 'SaishiApplyStep1',
                    components: {
                        default: require('@/page/apps/saishi/SaishiApplyStep1'),
                    }
                }, {
                    path: '/luntan-apply-index',
                    name: 'LuntanApplyIndex',
                    components: {
                        default: require('@/page/apps/luntan/LuntanApplyIndex'),
                    }
                },
                {
                    path: '/luntan-apply-step1',
                    name: 'LuntanApplyStep1',
                    components: {
                        default: require('@/page/apps/luntan/LuntanApplyStep1'),
                    }
                }, {
                    path: '/yishujie-apply-index',
                    name: 'YishujieApplyIndex',
                    components: {
                        default: require('@/page/apps/yishujie/YishujieApplyIndex'),
                    }
                },
                {
                    path: '/yishujie-apply-step1',
                    name: 'YishujieApplyStep1',
                    components: {
                        default: require('@/page/apps/yishujie/YishujieApplyStep1'),
                    }
                }, {
                    path: '/rencaiku-apply-index',
                    name: 'RencaikuApplyIndex',
                    components: {
                        default: require('@/page/apps/rencaiku/RencaikuApplyIndex'),
                    }
                },
                {
                    path: '/rencaiku-apply-step11',
                    name: 'RencaikuApplyStep11',
                    components: {
                        default: require('@/page/apps/rencaiku/RencaikuApplyStep11'),
                    }
                },
                {
                    path: '/rencaiku-apply-step21',
                    name: 'RencaikuApplyStep21',
                    components: {
                        default: require('@/page/apps/rencaiku/RencaikuApplyStep21'),
                    }
                },
                {
                    path: '/rencaiku-apply-step31',
                    name: 'RencaikuApplyStep31',
                    components: {
                        default: require('@/page/apps/rencaiku/RencaikuApplyStep31'),
                    }
                },
                {
                    path: '/rencaiku-apply-step41',
                    name: 'RencaikuApplyStep41',
                    components: {
                        default: require('@/page/apps/rencaiku/RencaikuApplyStep41'),
                    }
                }, {
                    path: '/tongyan-apply-index',
                    name: 'TongyanApplyIndex',
                    components: {
                        default: require('@/page/apps/tongyan/TongyanApplyIndex'),
                    }
                },
                {
                    path: '/tongyan-apply-step1',
                    name: 'TongyanApplyStep1',
                    components: {
                        default: require('@/page/apps/tongyan/TongyanApplyStep1'),
                    }
                },
                {
                    path: '/danwei-apply-form',
                    name: 'DanweiApplyForm',
                    components: {
                        default: require('@/page/apps/danwei/DanweiApplyForm'),
                    }
                },

            ]
        },
        {
            path: '/mine',
            name: 'mine',
            redirect: '/mineIndex',
            components: {
                default: require('@/page/user/mine/MineLayout'),
            },
            children: [{
                    path: '/mineIndex',
                    name: 'mineIndex',
                    components: {
                        default: require('@/page/user/mine/MineIndex'),
                    },
                    meta: {
                        title: '个人中心',
                        keepAlive: false,
                        tabs: [{
                            label: '用户列表',
                            pathName: 'mineIndex',
                        }]
                    }
                },

            ]
        },
        {
            path: '/user-setting',
            name: 'UserSetting',
            component: require('@/page/user/mine/setting/Setting'),
        },
        {
            path: '/user-password',
            name: 'UserPassword',
            component: require('@/page/user/mine/setting/Password'),
        },
        {
            path: '/cha-index',
            name: 'ChaIndex',
            component: require('@/page/apps/cha/ChaIndex'),
        },
        {
            path: '/cha-jiaolianList',
            name: 'ChaJiaolianList',
            component: require('@/page/apps/cha/JiaolianList'),
        },
        {
            path: '/cha-caipanList',
            name: 'ChaCaipanList',
            component: require('@/page/apps/cha/CaipanList'),
        },
        {
            path: '/cha-searchIndex',
            name: 'ChaSearchIndex',
            component: require('@/page/apps/cha/SearchIndex'),
        },
        {
            path: '/cha-searchAll',
            name: 'ChaSearchAll',
            component: require('@/page/apps/cha/SearchAll'),
        },
        {
            path: '/cha-searchPerson',
            name: 'ChaSearchPerson',
            component: require('@/page/apps/cha/SearchPerson'),
        },
        {
            path: '/cha-searchDanwei',
            name: 'ChaSearchDanwei',
            component: require('@/page/apps/cha/SearchDanwei'),
        },
        {
            path: '/cha-searchSai',
            name: 'ChaSearchSai',
            component: require('@/page/apps/cha/SearchSai'),
        },
        {
            path: '/huiyi-apply-form-step-1',
            name: 'HuiyiApplyFormStep1',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStep1'),
        },
        {
            path: '/huiyi-apply-form-step-2',
            name: 'HuiyiApplyFormStep2',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStep2'),
        },
        {
            path: '/huiyi-apply-form-step-3',
            name: 'HuiyiApplyFormStep3',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStep3'),
        },
        {
            path: '/huiyi-apply-form-step-5',
            name: 'HuiyiApplyFormStep5',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStep5'),
        },
        {
            path: '/huiyi-apply-form-success',
            name: 'HuiyiApplyFormSuccess',
            component: require('@/page/apps/huiyi/HuiyiApplyFormSuccess'),
        },
        {
            path: '/huiyi-apply-list',
            name: 'HuiyiApplyList',
            component: require('@/page/apps/huiyi/HuiyiApplyList'),
        },
        {
            path: '/huiyi-files-list',
            name: 'HuiyiFilesList',
            component: require('@/page/apps/huiyi/HuiyiFilesList'),
        },
        {
            path: '/wexame-my-exame-list',
            name: 'MyExameList',
            component: require('@/page/apps/wexame/MyExameList'),
        },
        {
            path: '/huiyi-index',
            name: 'HuiyiIndex',
            component: require('@/page/apps/huiyi/HuiyiIndex'),
        },
        {
            path: '/huiyi-list',
            name: 'HuiyiList',
            component: require('@/page/apps/huiyi/HuiyiList'),
        },
        {
            path: '/news-list',
            name: 'NewsList',
            component: require('@/page/apps/news/NewsList'),
        },
        {
            path: '/news-detail',
            name: 'NewsDetail',
            component: require('@/page/apps/news/NewsDetail'),
        },
        {
            path: '/course-index',
            name: 'CourseIndex',
            component: require('@/page/apps/course/CourseIndex'),
        },
        {
            path: '/course-detail',
            name: 'CourseDetail',
            component: require('@/page/apps/course/CourseDetail'),
        },
        {
            path: '/course-order-check',
            name: 'CourseOrderCheck',
            component: require('@/page/apps/course/CourseOrderCheck'),
        },
        {
            path: '/my-course-list',
            name: 'MyCourseList',
            component: require('@/page/apps/course/MyCourseList'),
        },
        {
            path: '/page-hangyejinying',
            name: 'PageHangyejinying',
            component: require('@/page/apps/page/Hangyejinying'),
        },
        {
            path: '/page-jigoushezhi',
            name: 'PageJigoushezhi',
            component: require('@/page/apps/page/Jigoushezhi'),
        },
        {
            path: '/page-saishizhaoshang',
            name: 'PageSaishizhaoshang',
            component: require('@/page/apps/page/Saishizhaoshang'),
        },
        {
            path: '/page-guojijiaoliu',
            name: 'PageGuojijiaoliu',
            component: require('@/page/apps/page/Guojijiaoliu'),
        },
        {
            path: '/page-wenhuaji',
            name: 'PageWenhuaji',
            component: require('@/page/apps/page/Wenhuaji'),
        },
        {
            path: '/page-yundongyuandengji',
            name: 'PageYundongyuandengji',
            component: require('@/page/apps/page/Yundongyuandengji'),
        },
        {
            path: '/cba-apply-list',
            name: 'CbaApplyList',
            component: require('@/page/apps/cba/CbaApplyList'),
        },
        {
            path: '/cba-apply-detail',
            name: 'CbaApplyDetail',
            component: require('@/page/apps/cba/CbaApplyDetail'),
        },
        {
            path: '/cba-apply-form-basic',
            name: 'CbaApplyFormBasic',
            component: require('@/page/apps/cba/CbaApplyFormBasic'),
        },
        {
            path: '/cba-apply-member-list',
            name: 'CbaApplyMemberList',
            component: require('@/page/apps/cba/CbaApplyMemberList'),
        },
        {
            path: '/cba-apply-member-add',
            name: 'CbaApplyMemberAdd',
            component: require('@/page/apps/cba/CbaApplyMemberAdd'),
        },
        {
            path: '/cba-apply-member-detail',
            name: 'CbaApplyMemberDetail',
            component: require('@/page/apps/cba/CbaApplyMemberDetail'),
        },
        {
            path: '/cba-apply-form-order',
            name: 'CbaApplyFormOrder',
            component: require('@/page/apps/cba/CbaApplyFormOrder'),
        },
        {
            path: '/h5',
            name: 'H5',
            component: require('@/page/index/H5'),
        },
    ],
})


// WEBPACK FOOTER //
// ./src/router/index.js